export default __webpack_public_path__ + "static/egg-a8085284aa1c26ff17cdc9c23ade73fe.png";